<template>
  <ImageBar 
    title="黑名单"
    imageUrl="https://picsum.photos/1200/500?random=4"
    height="80px"
  />

  <div class="dating-container">
    <div class="search-bar">
      <el-input
        v-model="searchQuery"
        placeholder="查找姓名、年龄、城市"
        class="search-input"
        clearable
        @clear="handleSearch"
        @input="handleSearch"
      >
        <template #prefix>
          <el-icon><Search /></el-icon>
        </template>
      </el-input>
    </div>

    <div class="dating-grid" v-loading="loading">
      <div v-for="person in blacklist" :key="person.uuid" class="profile-card">
        <div class="profile-photo" @click="viewPerson(person.uuid)">
          <el-image 
            :src="person.photo" 
            fit="cover"
            class="profile-image"
          >
            <template #error>
              <div class="image-placeholder">
                <el-icon><User /></el-icon>
              </div>
            </template>
          </el-image>
          <div class="profile-overlay">
            <div class="profile-basic">
              <h3>{{ person.name }}</h3>
              <div class="age-location">
                <span>{{ person.age }}岁</span>
                <el-divider direction="vertical" />
                <span>{{ person.location }}</span>
              </div>
            </div>
            <div class="profile-tags">
              <el-tag size="small" type="success">{{ person.height }}cm</el-tag>
              <el-tag size="small" type="warning">{{ person.occupation }}</el-tag>
              <el-tag size="small" type="info">{{ person.education }}</el-tag>
            </div>
          </div>
        </div>
        
        <div class="profile-actions">
          <el-button type="primary" text @click="viewPerson(person.uuid)">
            查看详情
          </el-button>
          <el-button type="danger" text @click="removeFromBlacklist(person.uuid)">
            移出黑名单
          </el-button>
        </div>
      </div>
    </div>

    <AdminPagination
      v-if="total > 0"
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :page-sizes="[12, 24, 36, 48]"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { Search, User } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import ImageBar from './components/ImageBar.vue'
import AdminPagination from '@/components/AdminPagination.vue'
import { resolveProfilePhotoUrl } from '@/utils/photoUpload'

export default {
  name: 'BlacklistView',
  components: {
    Search,
    User,
    ImageBar,
    AdminPagination
  },
  data() {
    return {
      loading: false,
      blacklist: [],
      currentPage: 1,
      pageSize: 12,
      total: 0,
      searchQuery: '',
      searchTimer: null
    }
  },
  created() {
  },
  watch: {
    currentPage: {
      handler() {
        this.fetchBlacklist()
      }
    },
    pageSize: {
      handler() {
        this.currentPage = 1
        this.fetchBlacklist()
      }
    }
  },
  mounted() {
    this.fetchBlacklist()
  },
  methods: {
    async fetchBlacklist() {
      this.loading = true
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/blacklist', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            page: this.currentPage,
            pageSize: this.pageSize,
            keyword: this.searchQuery
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          this.blacklist = data.data.blacklist.map(user => ({
            
            uuid: user.uuid,
            name: user.nickname || user.username,
            age: user.age || 0,
            location: user.city || '未知',
            height: user.height || 0,
            occupation: user.occupation || '未知',
            education: user.education || '未知',
            photo: resolveProfilePhotoUrl(user.avatar, user.photo) || 'https://example.com/default-avatar.jpg',
            interests: user.hobbies || [],
            description: user.introduction || ''
          }))
          this.total = data.data.total
        } else {
          ElMessage.error(data.message || '获取黑名单失败')
        }
      } catch (error) {
        ElMessage.error('获取黑名单失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1
        this.fetchBlacklist()
      }, 300)
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    viewPerson(id) {
      this.$router.push(`/profile/${id}`)
    },
    async removeFromBlacklist(uuid) {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/blacklist/del', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            targetUuid: uuid
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          ElMessage.success('已移出黑名单')
          this.fetchBlacklist()
        } else {
          ElMessage.error(data.message || '移出黑名单失败')
        }
      } catch (error) {
        ElMessage.error('移出黑名单失败')
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.dating-container {
  max-width: 880px;
  margin: 0 auto;
  padding: 20px;
}

.search-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.search-input {
  width: 300px;
}

.dating-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 20px;
}

@media (max-width: 767px) {
  .dating-container {
    padding: 0;
  }

  .dating-grid {
    gap: 8px;
    margin-bottom: 8px;
  }
}

.profile-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: all 0.3s;
}

.profile-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.profile-photo {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 125%;
  cursor: pointer;
}

.profile-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.profile-image:hover {
  transform: scale(1.05);
}

.profile-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: #fff;
}

.profile-basic h3 {
  margin: 0 0 8px 0;
  font-size: 1.2rem;
  color: #fff;
}

.age-location {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
}

.profile-tags {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.profile-actions {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
}

.profile-actions .el-button {
  background: rgba(255,255,255,0.85);
  color: #333;
  font-weight: bold;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: background 0.2s, color 0.2s;
}

.profile-actions .el-button:hover {
  background: #fff;
  color: #409EFF;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style> 